import { useEffect, useState } from "react";
import axios from "axios";
import Title from "../components/Title";
import Article from "../components/Article";

interface ArticleType {
  title: string;
  categories: string[];
  link: string;
  pubDate: string;
  guid: string;
  description: string;
}

const Articles = () => {
  const [articles, setArticles] = useState<ArticleType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(
        "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@ertemishakk",
      )
      .then((data) => {
        const res: ArticleType[] = data.data.items;
        setArticles(res.filter((item) => item.categories.length > 0));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="section">
      <Title title="Articles" />
      {loading && <p className="loading-line">fetching articles…</p>}
      {articles.map((article) => (
        <Article key={article.guid} article={article} />
      ))}
    </section>
  );
};

export default Articles;
